<!--
  功能：增强避险热门策略列表(产品1)
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2025-06-24 09:28:54
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'themeWhite'">
    <van-sticky>
      <div class="top-nav">
        <van-nav-bar left-arrow @click-left="onClickLeft">
          <template #left>
            <van-icon
              name="arrow-left"
              size="18"
              :color="$route.query.themeStyleVs == 2 ? '#e4e9fe' : '#000000 '"
            />
          </template>
          <template #title>
            <span :style="$route.query.themeStyleVs == 2 ? 'color:#e4e9fe;' : 'color:#000000;'"
              >热门策略</span
            >
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <div class="strategy-list">
      <div class="item" v-for="(item, index) in strategyList" :key="item.id" @click="gotoDetails(item.s_id)" >
        <div class="hd flex flex-space-between">
          <div class="title" >{{ item.s_name }}</div>
          <!-- <div class="follow" :class="{ active: item.follow }" @click.stop="handleFollow(index)">
            {{ item.follow ? '已关注' : '+ 关注' }}
          </div> -->

          <van-button
            plain
            type="primary"
            class="follow"
            :class="{ active: item.follow }"
            :loading="loadingIndex === index"
            @click.stop="handleFollow(index)"
            :icon="item.follow ? 'success' : 'plus'"
            >{{ item.follow ? '已关注' : '关注' }}</van-button
          >
        </div>
        <div class="desc">{{ item.s_desc }}</div>
        <div class="bd flex">
          <div class="flex-item">
            <div class="label">今日信号</div>
            <div class="value">{{ item.XinHaoShuLiang || '--' }}只</div>
          </div>
          <div class="flex-item">
            <div class="label">日涨幅</div>
            <div class="value" :class="[judgeColor(item.RiZhangFu)]">
              {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="strategy-more" @click="gotoMore()">查看更多策略 》</div>
    <div class="toast" v-if="showToast">
      <i class="icon-success"></i><span>{{ showToast === 1 ? '关注' : '取消' }}成功</span>
    </div>
  </div>
</template>

<script>
import { getStrategy } from '@/api/factor.js';
import { addMyFavor, delMyFavor } from '@/api/index.js';
import { getMyFavor } from '@/api/my.js';
import { judgeColor, toFixedNum, noRepeat, compareVersions } from '@/utils/format';

export default {
  name: '',
  data() {
    return {
      themeStyleVs: 0,
      showToast: false,
      strategyList: [],
      // 用户信息
      token: this.$route.query.token,
      // 用户关注的列表
      favorData: [],
      loadingIndex: null
    };
  },
  filters: {},
  // 侦听器
  watch: {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted: function () {
    this.loadData();
  },
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    async loadData() {
      var _this = this;
      this.strategyList = await this.getStrategyFunc();
      // 如果 token 存在，再请求 favor
      if (_this.token && _this.token !== 'NoToken') {
        this.favorData = await this.getMyFavorFunc();
        this.compareData(); // 场景1：两个都请求完后比较
      } else {
        this.favorData = null;
      }
    },
    // 获取用户列表
    async getStrategyFunc() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        getStrategy({})
          .then((result) => {
            if (result.err == 200) {
              resolve(result.data);
            }
          })
          .catch((err) => {
            reject({});
          });
      });
    },

    // 获取我关注的策略
    async getMyFavorFunc() {
      return new Promise((resolve, reject) => {
        let _this = this;
        let obj = {
          start: 1,
          count: 200,
          type: 'cl',
          type_info: 1 //0全部  1A股 2ETF
        };
        getMyFavor(obj)
          .then((result) => {
            if (result.err == 200) {
              resolve(result.data.listData);
            } else {
              reject({});
            }
          })
          .catch((err) => {
            reject({});
          });
      });
    },
    // 数据交集比较
    compareData: function () {
      if (this.strategyList && this.favorData) {
        // 先提取 arr2 中所有 s_id 到 Set，便于高效查找
        const sidsInArr2 = new Set(this.favorData.map((item) => item.s_id));
        // 给 arr1 增加 follow 字段
        this.strategyList.forEach((item) => {
          this.$set(item, 'follow', sidsInArr2.has(item.s_id) ? 1 : 0);
        });
      }
    },
    // 关注
    handleFollow: function (index) {
      var _this = this;
      if (_this.token && _this.token !== 'NoToken') {
        _this.loadingIndex = index;
        // 走关注接口
        if (_this.strategyList[index].follow == 1) {
          // 如果关注走取消关注
          let obj = {
            type: 1,
            id: _this.strategyList[index].s_id
          };
          delMyFavor(obj).then((res) => {
            if (res.err === 200) {
              _this.strategyList[index].follow = 0;
              _this.showToast = 2;
              setTimeout(function () {
                _this.showToast = false;
              }, 1000);
            }
          });
        } else {
          // 走关注接口
          let obj = {
            type: 1,
            id: _this.strategyList[index].s_id,
            s_name: _this.strategyList[index].s_name,
            f_id_arr: _this.strategyList[index].f_id_arr,
            creator: _this.strategyList[index].creator,
            type_info: _this.strategyList[index].type_info
          };
          addMyFavor(obj).then((res) => {
            if (res.err === 200) {
              _this.strategyList[index].follow = 1;
              _this.showToast = 1;
              setTimeout(function () {
                _this.showToast = false;
              }, 1000);
            }
          });
        }

        setTimeout(function () {
          _this.loadingIndex = null;
        }, 500);
      } else {
        // 跳转登录
        window.location.href = 'dzh_browser_url&goto=0&screen=442';
      }
    },
    // 点击关注更多
    gotoMore: function () {
      var _this = this;
      if (_this.token && _this.token !== 'NoToken') {
        location.href = '/home?DZHSPECIAL=4325640';
      } else {
        // 跳转登录
        window.location.href = 'dzh_browser_url&goto=0&screen=442';
      }
    },
    // 点击策略详情
    gotoDetails: function (sId) {
      var _this = this;
      if (_this.token && _this.token !== 'NoToken') {
        location.href = '/clDetail?DZHSPECIAL=4325641&type=hot&s_id=' + sId;
      } else {
        // 跳转登录
        window.location.href = 'dzh_browser_url&goto=0&screen=442';
      }
    },
    // 点击返回
    onClickLeft: function () {
      // 关闭当前页面
      window.location.href = 'dzh_browser_url&goto=0&screen=263';
    }
  }
};
</script>

<style scoped lang="less">
.flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.flex-item {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.flex-space-between {
  justify-content: space-between;
  .van-button::before {
    // 背景色透明
    background-color: transparent;
  }
}

.flex-wrap {
  flex-wrap: wrap;
}

.strategy-list {
  padding: 10px;
}

.strategy-list .item {
  background: #272935;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 14px 16px;
}

.strategy-list .item .title {
  font-size: 16px;
  font-weight: 500;
}

.strategy-list .item .follow {
  display: flex;
  align-items: center;
  border-radius: 88px;
  border: 1px solid #2057c5;
  color: #3b85fe;
  font-size: 12px;
  height: 22px;
  padding: 2px 8px;
  background-color: transparent;
  .van-button__icon {
    // width: 10px;
    // height: 10px;
    font-size: 10px;
  }
}

.strategy-list .item .follow.active {
  border-color: #6b7687;
  color: #6b7687;
}

// .strategy-list .item .follow.active::before {
//   content: '';
//   display: inline-block;
//   width: 10px;
//   height: 10px;
//   margin-right: 4px;
//   background: url('../../assets/image/hedging/tick.png') no-repeat;
//   background-size: 100% auto;
// }

.strategy-list .item .desc {
  color: #aab9d1;
  font-size: 12px;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.strategy-list .item .bd {
  text-align: center;
  padding-top: 14px;
}

.strategy-list .item .bd .label {
  color: #6b7687;
  font-size: 12px;
}

.strategy-list .item .bd .value {
  color: #e4e9fe;
  font-size: 16px;
  line-height: 24px;
}

.strategy-more {
  color: #4d8cf9;
  font-size: 14px;
  //   padding: 10px 0;
  padding-bottom: 10px;
  text-align: center;
}

.toast {
  display: flex;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  height: 42px;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.9);
  border-radius: 12px;
  padding: 0 20px;
  font-size: 14px;
  color: #fff;
}

.icon-success {
  display: inline-block;
  width: 22px;
  height: 22px;
  background: url('../../assets/image/hedging/success.png') no-repeat;
  background-size: 100% auto;
  margin-right: 8px;
}
.themeWhite {
  min-height: 100vh;
  .top-nav {
    padding-top: 44px;
    background-color: #fff;
  }
}
.themeWhite {
  background-color: #f2f3f5;
  color: #1d2129;
}

.themeWhite .strategy-list .item {
  background-color: #fff;
}

.themeWhite .strategy-list .item .title {
  color: #1d2129;
  flex: 1;
}

.themeWhite .strategy-list .item .follow {
  border-color: #4d8cf9;
  color: #286df7;
}

.themeWhite .strategy-list .item .follow.active {
  border-color: #c9cdd4;
  color: #949da8;
}

.themeWhite .strategy-list .item .follow.active::before {
  background-image: url('../../assets/image/hedging/tick2.png');
}

.themeWhite .strategy-list .item .desc {
  color: #4e5969;
}

.themeWhite .strategy-list .item .bd .label {
  color: #949da8;
}

.themeWhite .strategy-list .item .bd .value {
  color: #1d2129;
}

.themeWhite .strategy-more {
  color: #4d8cf9;
}

// 黑版样式
.black_theme {
  .top-nav {
    padding-top: 44px;
    background-color: #1a1c26;
  }
  .strategy-list .item .title {
    color: #e4e9fe;
    flex: 1;
  }
  .van-nav-bar {
    background-color: #1a1c26;
  }
  .van-nav-bar__title {
    color: #e4e9fe !important;
  }
}
</style>
